import { Box, Card, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { Resources } from '../../resource';
import TypeConfigList from './List';
import { RedPacketType } from '../../../services/redpacketService';
import '../dataProvider';
import { useTranslate } from 'react-admin';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`redpacket-tabpanel-${index}`}
      aria-labelledby={`redpacket-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const RedPacketList = () => {
  const [tabValue, setTabValue] = useState(0);
  const t = useTranslate();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <DashboardContent>
      <CustomBreadcrumbs
        heading={t('module.redpacket.typeConfig')}
        links={[{ name: t('module.redpacket.redPacketManagement') }, { name: t('module.redpacket.typeConfig') }]}
      />

      <Card sx={{ mt: 3 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label={t('module.redpacket.tabAriaLabel')}>
            <Tab label={t('module.redpacket.tabTwitterBinding')} />
            <Tab label={t('module.redpacket.tabTwitterFollow')} />
            <Tab label={t('module.redpacket.tabDeposit')} />
            <Tab label={t('module.redpacket.tabTrading')} />
            <Tab label={t('module.redpacket.tabCriticalHit')} />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <TypeConfigList typeFilter={RedPacketType.TWITTER_BINDING} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <TypeConfigList typeFilter={RedPacketType.TWITTER_FOLLOW} />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <TypeConfigList typeFilter={RedPacketType.DEPOSIT} />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <TypeConfigList typeFilter={RedPacketType.TRADING} />
        </TabPanel>
        <TabPanel value={tabValue} index={4}>
          <TypeConfigList typeFilter={RedPacketType.CRITICAL_HIT} />
        </TabPanel>
      </Card>
    </DashboardContent>
  );
};

export default RedPacketList;
